import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map, retry } from 'rxjs/operators';
import { AuthHttp } from '../http/http.service';
import { AuthenticationService } from '../auth/authentication.service';
import { ServiceEvent, ServiceEventStatus } from '@app/models/ServiceEvent';
import { TipoGrupos } from '@global-service/storage';
import { asError, requestWithResponse } from '../http/request-with-response';

type TipoEmpresa = 'empresa_deipe' | 'grupo_empresas';
interface ServerData {
  ambito_id: number;
  cdg_grupo: TipoGrupos;
  configuracion_completa: 'SI' | 'NO'
  dominio: string;
  entorno_id: string;
  id: number;
  id_grupo_conf: string;
  nombre_logo_carga: string;
  nombre_logo_login: string;
  nombre_logo_menu: string;
  razon_social: string;
  sector: string;
  subdominio: string;
  uso_tramitado_encargos: number;
  usuario_comunicacion: number;
}
export interface ArbolGrupoHijo {
  empresa_id: number;
  grupo_id: string;
  hasChildren: string;
  name: string;
  server_data: ServerData;
  type: TipoEmpresa;
}
export interface ArbolGrupo {
  codigo: string;
  grupo_id: string;
  name: string;
  type: string;
  children: ArbolGrupoHijo;
}
@Injectable()
export class ArbolService {
  private readonly emitter = new EventEmitter();

  public currentSucursales: any;
  private arbolGrupo: ArbolGrupo[] | ArbolGrupoHijo[] = [];

  constructor(private readonly http: AuthHttp, private readonly authService: AuthenticationService) {}

  // Es necesario dos gets porque se sobreescribe la variable arbolGrupo, dependiendo si eres super admin (ArbolGrupo) o entras con un dominio. (ArbolGrupoHijo)
  getArbolGrupo() {
    return this.arbolGrupo as ArbolGrupo[]
  }
  getArbolGrupoHijo() {
    return this.arbolGrupo as ArbolGrupoHijo[]
  }
  initArbolGrupo() {
    this.arbolGrupo = [];
  }
  init() {
    const grupos = this.arbolGrupo;
    return new Promise((resolve, reject) => {
      if (grupos.length > 0) {
        resolve(grupos);
      } else {
        this.getGrupos().then(
          response => {
            this.arbolGrupo = response as ArbolGrupo[];
            resolve(this.arbolGrupo);
          },
          errorResponse => reject(asError(errorResponse))
        );
      }
    });
  }
  getGrupos(reset?) {
    if (reset) {
      Object.keys(localStorage).forEach(function(key) {
        if (/^(SucursalService)/.test(key)) {
          localStorage.removeItem(key);
        }
        if (/^(ArbolService)/.test(key)) {
          localStorage.removeItem(key);
        }
      });
    }
    const dominio = localStorage.getItem('dominio');
    return requestWithResponse<any[]>(
      this.http.post(`${environment.apiURLs.private}/arbol/grupos`, { dominio }).pipe(
        retry(2),
        map((response: any) => {
          const data = Array.isArray(response) ? response : response?.data ?? response?.result;
          let objects: any[] = Array.isArray(data) ? data : [];
          if (objects?.length === 1 && objects[0]?.children && !this.authService.tienePermisodeGrupo()) {
            objects = objects[0].children;
          }
          if (this.authService.tienePermisodeGrupo() && objects[0]) objects[0].children = [];
          return objects;
        })
      ),
      response => { this.arbolGrupo = response; },
      asError
    );
  }

  getSucursales(empresa_id, force: boolean = false) {
    this.emitter.emit(new ServiceEvent(ServiceEventStatus.loading, true));

    const storage = localStorage.getItem(ArbolService.name + '' + empresa_id);

    if (!force && storage) {
        const sucursales = JSON.parse(storage);
        this.emitter.emit(new ServiceEvent(ServiceEventStatus.fetched, sucursales));
        this.emitter.emit(new ServiceEvent(ServiceEventStatus.loading, false));
        this.currentSucursales = sucursales;
        return Promise.resolve(sucursales);
    }

      const dominio = localStorage.getItem('dominio');
      const tienda_id = this.authService.getCurrentUser().tienda;

    return requestWithResponse<any[]>(this.http
        .post(`${environment.apiURLs.private}/arbol/empresa/${empresa_id}/sucursales`, { dominio })
        .pipe(
          retry(2),
          map((objects: any) => {
            if (!this.authService.can('consulta_datos_compartidos_tiendas')) {
              const output = [];
              for (const iterator of objects) {
                if (iterator.server_data.id === tienda_id) {
                  output.push(iterator);
                }
              }
              return output;
            }
            return objects;
          })
        )
        , response => {
            this.emitter.emit(new ServiceEvent(ServiceEventStatus.fetched, response));
            this.emitter.emit(new ServiceEvent(ServiceEventStatus.loading, false));
            localStorage.setItem(ArbolService.name + '' + empresa_id, JSON.stringify(response));
            localStorage.setItem('configuraciones_tienda', JSON.stringify(response));
          },
          () => {
            this.emitter.emit({
              type: 'loading',
              value: false
            });
            return [];
          }
    );
  }
  getEmitter() {
    return this.emitter;
  }
}
